import type { ServerPaginationConfig } from '@shared/types/module-config';

export const PIX_TRANSFERS_PAGINATION: ServerPaginationConfig = {
  enabled: true,
  mode: 'server',
  pageParam: 'page',
  sizeParam: 'size',
  defaultSize: 10,
  firstPage: 0,
  sendPageIfDefault: true,
};

export const PIX_TRANSFERS_ROUTE_PATHS = {
  pixTransfers: '/movements/pix-transfers',
};

export const PIX_TRANSFERS_API_PATHS = {
  transfers: '/v1/api/platform/transfer-gateway/pix/transfers/all',
  transferStatus: '/v1/api/platform/transfer-gateway/transfer-status',
  transferDetail: '/v1/api/platform/transfer-gateway/pix/transfers-detail',
  retryReturn: '/v1/api/platform/transfer-gateway/pix/transfer',
  reverseTransfer: '/v1/api/platform/transfer-gateway/reversal/crypto_address',
  creditWallet: '/v1/api/platform/transfer-gateway/credit_wallet/crypto_address',
  reNotifyIncoming: '/v1/api/platform/transfer-gateway/notify/incoming',
};

export const ORIGIN_TYPES = [
  'AM_INVESTMENTS',
  'COMPANY_TRANSFER',
  'EXCHANGE',
  'INTERNAL_P2P_TRANSFER',
  'MERCHANT_TRANSFER',
  'P2P_TRANSFER',
  'PAYMENT_LINK',
  'QR_PAYMENT',
  'TRANSFER_TP',
];

export const SCHEME_NAMES = [
  'ASTROPAY',
  'BANK_ACCOUNT',
  'CCI',
  'CLABE',
  'CVU',
  'IBAN',
  'PIX',
  'QR_PAYMENT',
  'SAVINGS',
  'USD_ACCOUNT',
  'CRYPTO_ADDRESS',
];

export const TRANSFER_TYPES = ['INCOMING', 'OUTGOING'];
